import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import {
  UserIcon,
  Cog6ToothIcon,
  KeyIcon,
  ArrowRightOnRectangleIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const userNavigation = [
  { name: 'Profile', to: '/profile', icon: UserIcon },
  { name: 'Security', to: '/security', icon: ShieldCheckIcon },
  { name: 'API Keys', to: '/api-keys', icon: KeyIcon },
  { name: 'Settings', to: '/settings', icon: Cog6ToothIcon },
];

export default function UserDropdown() {
  return (
    <Menu as="div" className="relative z-[100]">
      <Menu.Button className="p-2 text-white/60 hover:text-white hover:bg-white/[0.04] transition-colors duration-200 rounded-lg">
        <div className="h-8 w-8 bg-white/[0.05] flex items-center justify-center rounded-lg">
          <UserIcon className="h-5 w-5" />
        </div>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="fixed right-6 top-[4.5rem] w-56 origin-top-right bg-[#1a1b2e]/95 backdrop-blur-lg rounded-lg divide-y divide-white/[0.05] shadow-xl ring-1 ring-white/[0.05] focus:outline-none isolate">
          <div className="px-4 py-3">
            <p className="text-sm font-medium text-white">John Doe</p>
            <p className="text-sm text-white/50 truncate">
              john.doe@example.com
            </p>
          </div>
          <div className="py-1">
            {userNavigation.map((item) => {
              const Icon = item.icon;
              return (
                <Menu.Item key={item.name}>
                  {({ active }: { active: boolean }) => (
                    <Link
                      to={item.to}
                      className={`group flex items-center px-4 py-2 text-sm ${
                        active
                          ? 'bg-white/[0.02] text-white'
                          : 'text-white/70'
                      }`}
                    >
                      <Icon
                        className="mr-3 h-5 w-5"
                        aria-hidden="true"
                      />
                      {item.name}
                    </Link>
                  )}
                </Menu.Item>
              );
            })}
          </div>
          <div className="py-1">
            <Menu.Item>
              {({ active }: { active: boolean }) => (
                <button
                  className={`w-full flex items-center px-4 py-2 text-sm ${
                    active
                      ? 'bg-white/[0.02] text-rose-400'
                      : 'text-rose-400/70'
                  }`}
                  onClick={() => {
                    // TODO: Implement logout
                    console.log('Logout clicked');
                  }}
                >
                  <ArrowRightOnRectangleIcon
                    className="mr-3 h-5 w-5"
                    aria-hidden="true"
                  />
                  Sign out
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
